<div class="sidebar-tab-icon">
    <adapt-icon [icon]="iconClassValue"></adapt-icon>
    <div *ngIf="iconText"
         class="icon-text">{{iconText}}</div>
</div>
